export const fmtMoney = (n, currency = "USD") => {
  if (n === null || n === undefined || isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency, maximumFractionDigits: 0,
  }).format(Number(n));
};

export const fmtNum = (n) => {
  if (n === null || n === undefined || isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("en-US").format(Number(n));
};

export const fmtFecha = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("es-ES", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return "—"; }
};

export const fmtFechaCorta = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "—"; }
};

export const fmtProximoLocal = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const fecha = d.toLocaleDateString("es-ES", { weekday: "short", day: "2-digit", month: "short" });
    const hora = d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
    return `${fecha} · ${hora}`;
  } catch { return "—"; }
};

export const fmtHora = (d = new Date()) =>
  d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit" });

export const fmtDuracion = (min) => {
  if (min === null || min === undefined || isNaN(Number(min))) return "—";
  const m = Math.round(Number(min));
  if (m <= 0) return "—";
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60), r = m % 60;
  return r ? `${h} h ${String(r).padStart(2, "0")} min` : `${h} h`;
};

export const diasHasta = (iso) => {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
};

export const fmtHace = (iso) => {
  if (!iso) return "—";
  try {
    const seg = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
    if (seg < 60) return "hace unos segundos";
    const min = Math.floor(seg / 60);
    if (min < 60) return `hace ${min} min`;
    const h = Math.floor(min / 60);
    return `hace ${h} h`;
  } catch { return "—"; }
};
